module.exports = __webpack_public_path__ + "static/media/Grace Anyetei - Profile pic.6f6fad15.jpg";